import React, { useEffect, useState } from 'react';
import './CalcAProofDtInput.css';

// import {
//     createColumnHelper,
//     flexRender,
//     getCoreRowModel,
//     useReactTable,
// } from '@tanstack/react-table'
import { AProofElectrolyzer, CalcAProofResultDefaultData } from '../parts/CalcAProofData';


const defaultData: AProofElectrolyzer[] =
    CalcAProofResultDefaultData.electroyzerList ? CalcAProofResultDefaultData.electroyzerList : [];

// const columnHelper = createColumnHelper<AProofUnit>()

// const columns = [
//     // 日時
//     columnHelper.accessor('calculationDt', {
//         header: () => 'Day and time',
//         cell: info => info.getValue(),
//     }),
// ]

const rows = [
    {label: 'INPUT', unit: 'unit', key: 'input', data: 'operate', fraction: 0},
    {label: 'No.', unit: '-', key: 'no', data: 'no', fraction: 0},
    {label: 'Electrolyzer', unit: '-', key: 'electrolyzer', data: 'electrolyzer'},
    {label: 'Operate', unit: '-', key: 'operate', data: 'operate'},
    {label: 'Number of Cells', unit: 'cells', key: 'cells', data: 'cells', fraction: 0},
    {label: 'Actual Operation', unit: '-', key: 'operation', data: '-', titleOnly: true},
    {label: '   Current', unit: 'kA', key: 'current', data: 'current', fraction: 2},
    {label: '   Elec. Voltage', unit: 'V', key: 'voltage', data: 'voltage', fraction: 1},
    {label: '   NaOH Outlet Temp.', unit: 'degC', key: 'temp', data: 'temp', fraction: 1},
    {label: 'Current Efficiency', unit: '%', key: 'currentEfficiency', data: 'currentEfficiency', style: "decimal", fraction: 2},
    {label: 'Current Range', unit: '-', key: 'currentRange', data: '-', titleOnly: true},
    {label: '   Max.', unit: 'kA', key: 'rangeMax', data: 'rangeMax', fraction: 2},
    {label: '   Min.', unit: 'kA', key: 'rangeMin', data: 'rangeMin', fraction: 2},
    {label: 'NaOH Production', unit: 'MT/D', key: 'naohProduction', data: 'naohProduction', fraction: 1},
    {label: 'Estimated NaCl in 50% NaOH', unit: 'ppm', key: 'naclInNaoh50', data: 'naclInNaoh50', fraction: 0},
    {label: 'PC', unit: 'kWh/MT', key: 'pc', data: 'pc', fraction: 1},
]

type Props = {
    units: AProofElectrolyzer[],
}

export const CalcAProofDtInput: React.FC<Props> = ({units}) => {
    const [data, setData] = React.useState(() => [...defaultData])

    useEffect(() => {
        console.log('CalcAProofDtInput: update. units.length=' + units.length);
        setData(units);
        console.log('CalcAProofDtInput: update. data.length=' + data.length);
    }, [units]);
    // const table = useReactTable({
    //     data,
    //     columns,
    //     getCoreRowModel: getCoreRowModel(),
    // })

    return (
        <div className="CalcAProofDtInput_content CalcAProofDtInput_table">
            <table>
                <tbody>
                    {rows.map(row => (
                        <tr key={row.key}>
                            <th>
                                {row.label}
                            </th>
                            <td className="CalcAProofDtIntput_cell_unit">
                                {row.unit}
                            </td>
                            {data.map((unit, index) => {
                                //console.log('CalcAProofDtInput: index=' + index);
                                //console.log(unit);
                                if (row.titleOnly === true) {
                                    return (
                                        <td key={index}>
                                            -
                                        </td>
                                    );
                                } else {
                                    if (unit.input === undefined) {
                                        return (
                                            <td key={index}>
                                                
                                            </td>
                                        );
                                    } else {
                                        //console.log('key=' + row.key);
                                        //console.log(row.key in unit.input);
                                        if (row.data in unit.input) {
                                            let data : keyof typeof unit.input = row.data as keyof typeof unit.input;
                                            let cellData = unit.input[data];
                                            let fraction = row.fraction ? row.fraction : 0;
                                            let style = row.style ? row.style : "decimal";
                                            //console.log('key=' + row.key + ", cellData=" + cellData);

                                            if (row.label === "INPUT") {
                                                let clazz =
                                                    ("operate" === cellData?.toString().toLowerCase()) ?
                                                        "CalcAProofDtInput_operate_op" :
                                                        "CalcAProofDtInput_operate_stop";
                                                //console.log('key=input clazz=' + clazz);
                                                return (
                                                    <td key={index}>
                                                        <span className={clazz}></span>
                                                    </td>
                                                );
                                            } else {
                                                return (
                                                    <td key={index}>
                                                        {
                                                            typeof cellData == "number" ?
                                                                cellData.toLocaleString(
                                                                    undefined,
                                                                    {
                                                                        style: style,
                                                                        minimumFractionDigits: fraction,
                                                                        maximumFractionDigits: fraction
                                                                }) :
                                                                cellData
                                                        }
                                                    </td>
                                                );
                                            }
    
                                        } else {
                                            return (
                                                <td key={index}>
                                                    
                                                </td>
                                            );
                                        }
                                    }
                                }
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
